import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./MainMenu.css";

function MainMenu() {
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();

    const closeMenu = () => {
        setMenuOpen(false);
    };

    // Close mobile menu automatically when route changes
    useEffect(() => {
        setMenuOpen(false);
    }, [location.pathname]);

    // Prevent background scrolling while mobile menu is open
    useEffect(() => {
        if (menuOpen) {
            document.body.classList.add("mobile-menu-open");
        } else {
            document.body.classList.remove("mobile-menu-open");
        }

        return () => {
            document.body.classList.remove("mobile-menu-open");
        };
    }, [menuOpen]);

    const isActive = (path) => {
        if (path === "/") {
            return location.pathname === "/";
        }

        return location.pathname.startsWith(path);
    };

    return (
        <>
            <header className="temple-header">
                <div className="temple-navbar">

                    {/* BRAND */}
                    <Link
                        to="/"
                        className="temple-brand"
                        onClick={closeMenu}
                    >
                        <div className="temple-logo-wrapper">
                            <img
                                src="./images/shiva.png"
                                alt="Azhimala Shiva Temple"
                                className="temple-logo"
                            />
                        </div>

                        <div className="temple-brand-text">
                            <span className="temple-name">
                                Azhimala Siva Temple
                            </span>

                            <span className="temple-subtitle">
                                Kerala
                            </span>
                        </div>
                    </Link>

                    {/* DESKTOP MENU */}
                    <nav className="desktop-menu">

                        <Link
                            to="/"
                            className={`nav-item ${
                                isActive("/") ? "active" : ""
                            }`}
                        >
                            Home
                        </Link>

                        <Link
                            to="/History"
                            className={`nav-item ${
                                isActive("/History") ? "active" : ""
                            }`}
                        >
                            History
                        </Link>

                        

                        <Link
                            to="/Timing"
                            className={`nav-item ${
                                isActive("/Timing") ? "active" : ""
                            }`}
                        >
                            Darsan Time
                        </Link>

                        <Link
                            to="/Administration"
                            className={`nav-item ${
                                isActive("/Administration") ? "active" : ""
                            }`}
                        >
                            Administration
                        </Link>

                        <Link
                            to="/Gallery"
                            className={`nav-item ${
                                isActive("/Gallery") ? "active" : ""
                            }`}
                        >
                            Gallery
                        </Link>

                        <Link
                            to="/Contact"
                            className={`nav-item ${
                                isActive("/Contact") ? "active" : ""
                            }`}
                        >
                            Contact
                        </Link>

                        {/* <Link to="/online-pooja-booking"
                            className="nav-item booking-link"
                           
                            rel="noopener noreferrer"
                        >
                            Pooja Booking
                        </Link>
                        <Link to="/pooja-login"
                            style={{border:'1px solid white'}}
                            className={`nav-item ${
                                isActive("/pooja-login") ? "active" : ""
                            }`}
                            onClick={closeMenu}
                        >
                            <span>Booking Status</span>
                           
                        </Link> */}

                    </nav>

                    {/* MOBILE HAMBURGER */}
                    <button
                        className={`mobile-menu-button ${
                            menuOpen ? "open" : ""
                        }`}
                        onClick={() => setMenuOpen(!menuOpen)}
                        aria-label="Toggle navigation"
                        aria-expanded={menuOpen}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>

                </div>

                {/* MOBILE MENU */}
                <div
                    className={`mobile-menu ${
                        menuOpen ? "mobile-menu-show" : ""
                    }`}
                >
                    <nav className="mobile-menu-inner">

                        <Link
                            to="/"
                            className={`mobile-nav-item ${
                                isActive("/") ? "active" : ""
                            }`}
                            onClick={closeMenu}
                        >
                            <span>Home</span>
                            <span className="menu-arrow">›</span>
                        </Link>

                        <Link
                            to="/History"
                            className={`mobile-nav-item ${
                                isActive("/History") ? "active" : ""
                            }`}
                            onClick={closeMenu}
                        >
                            <span>History</span>
                            <span className="menu-arrow">›</span>
                        </Link>

                     

                        <Link
                            to="/Timing"
                            className={`mobile-nav-item ${
                                isActive("/Timing") ? "active" : ""
                            }`}
                            onClick={closeMenu}
                        >
                            <span>Darsan Time</span>
                            <span className="menu-arrow">›</span>
                        </Link>

                        <Link
                            to="/Administration"
                            className={`mobile-nav-item ${
                                isActive("/Administration") ? "active" : ""
                            }`}
                            onClick={closeMenu}
                        >
                            <span>Administration</span>
                            <span className="menu-arrow">›</span>
                        </Link>

                        <Link
                            to="/Gallery"
                            className={`mobile-nav-item ${
                                isActive("/Gallery") ? "active" : ""
                            }`}
                            onClick={closeMenu}
                        >
                            <span>Gallery</span>
                            <span className="menu-arrow">›</span>
                        </Link>

                        <Link
                            to="/Contact"
                            className={`mobile-nav-item ${
                                isActive("/Contact") ? "active" : ""
                            }`}
                            onClick={closeMenu}
                        >
                            <span>Contact</span>
                            <span className="menu-arrow">›</span>
                        </Link>
                           {/* <Link to="/online-pooja-booking"
                           
                            className="mobile-nav-item mobile-booking"
                           rel="noopener noreferrer"
                            onClick={closeMenu}
                        >
                            <span>Pooja Booking</span>
                            <span className="menu-arrow">›</span>
                        </Link>
                         <Link to="/pooja-login"
                           
                            className="mobile-nav-item "
                           rel="noopener noreferrer"
                            onClick={closeMenu}
                        >
                            <span>Booking Status</span>
                            <span className="menu-arrow">›</span>
                        </Link> */}

                    </nav>
                </div>
            </header>

            {/* Overlay */}
            {menuOpen && (
                <div
                    className="mobile-menu-overlay"
                    onClick={closeMenu}
                ></div>
            )}
        </>
    );
}

export default MainMenu;